import { render, staticRenderFns } from "./SplitOrderDialog.vue?vue&type=template&id=f8a9223e&scoped=true&"
import script from "./SplitOrderDialog.vue?vue&type=script&lang=js&"
export * from "./SplitOrderDialog.vue?vue&type=script&lang=js&"
import style0 from "./SplitOrderDialog.vue?vue&type=style&index=0&id=f8a9223e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a9223e",
  null
  
)

export default component.exports